export const headings = {
  organization: {
    en: 'Organization',
    hi: 'संगठन',
  },
  resources: {
    en: 'Resources',
    hi: 'संसाधन',
  },
  opportunities: {
    en: 'Opportunities',
    hi: 'संसाधन',
  },
  portalsAndForms: {
    en: 'Portals And Forms',
    hi: 'संसाधन',
  },
  womenAndCitizenSupport: {
    en: 'Women and Citizen Support',
    hi: 'महिलाएँ और नागरिक सहायता',
  },
  communication: {
    en: 'Communication',
    hi: 'संचार',
  },
  additionalLinks: {
    en: 'Additional Links',
    hi: 'अतिरिक्त लिंक',
  },
};

// export const links = {
//   organization: [
//     {
//       title: {
//         en: 'About',
//         hi: 'आरटीएम लिंक'
//       },
//       path: '/about-us'
//     },
//     {
//       title: {
//         en: 'Careers',
//         hi: 'आरटीएम लिंक'
//       },
//       path: '/about/careers'
//     }
//   ],
//   resources: [
//     {
//       title: {
//         en: 'RTM Link',
//         hi: 'आरटीएम लिंक'
//       },
//       path: '/rtm-link'
//     },
//     {
//       title: {
//         en: 'Annual Reports',
//         hi: 'वार्षिक रिपोर्ट'
//       },
//       path: '/annual-reports'
//     },
//     {
//       title: {
//         en: 'Events',
//         hi: 'इवेंट्स'
//       },
//       path: '/events'
//     },
//     {
//       title: {
//         en: 'Guest House',
//         hi: 'अतिथि गृह'
//       },
//       path: '/guest-house'
//     },
//     {
//       title: {
//         en: 'Vacancies',
//         hi: 'रिक्तियाँ'
//       },
//       path: '/vacancies'
//     },
//     {
//       title: {
//         en: 'Recruitment Results',
//         hi: 'भर्ती परिणाम'
//       },
//       path: '/recruitment-results'
//     },
//     {
//       title: {
//         en: 'Call For Proposals',
//         hi: 'प्रस्ताव के लिए कॉल'
//       },
//       path: '/call-for-proposals'
//     },
//     {
//       title: {
//         en: 'Download Forms',
//         hi: 'फॉर्म डाउनलोड करें'
//       },
//       path: '/download-forms'
//     },
//     {
//       title: {
//         en: 'Photo Gallery',
//         hi: 'फोटो गैलरी'
//       },
//       path: '/photo-gallery'
//     },
//     {
//       title: {
//         en: 'MIHIR Portal',
//         hi: 'MIHIR पोर्टल'
//       },
//       path: '/mihir-portal'
//     },
//     {
//       title: {
//         en: 'NCMRWF Library Portal',
//         hi: 'NCMRWF पुस्तकालय पोर्टल'
//       },
//       path: '/ncmrwf-library-portal'
//     },
//     {
//       title: {
//         en: 'Tenders',
//         hi: 'टेंडर'
//       },
//       path: '/tenders'
//     },
//     {
//       title: {
//         en: 'Notices',
//         hi: 'सूचनाएँ'
//       },
//       path: '/notices'
//     },
//     {
//       title: {
//         en: 'RTI Section',
//         hi: 'आरटीआई अनुभाग'
//       },
//       path: '/rti-section'
//     }
//   ],
//   womenAndCitizenSupport: [
//     {
//       title: {
//         en: 'ICC For Women',
//         hi: 'महिलाओं के लिए आईसीसी'
//       },
//       path: '/icc-for-women'
//     },
//     {
//       title: {
//         en: 'Citizen Charter',
//         hi: 'नागरिक चार्टर'
//       },
//       path: '/citizen-charter'
//     },
//     {
//       title: {
//         en: 'Grievance Cell',
//         hi: 'शिकायत सेल'
//       },
//       path: '/grievance-cell'
//     }
//   ],
//   communication: [
//     {
//       title: {
//         en: 'Newsletter',
//         hi: 'न्यूज़लेटर'
//       },
//       path: '/newsletter'
//     },
//     {
//       title: {
//         en: 'Useful External Info',
//         hi: 'उपयोगी बाहरी जानकारी'
//       },
//       path: '/useful-external-info'
//     },
//     {
//       title: {
//         en: 'Disclaimer',
//         hi: 'अस्वीकृति'
//       },
//       path: '/disclaimer'
//     },
//     {
//       title: {
//         en: 'Web Administrator',
//         hi: 'वेब व्यवस्थापक'
//       },
//       path: '/web-administrator'
//     }
//   ],
//   additionalLinks: [
//     {
//       title: {
//                 en: 'Privacy Policy',
//                 hi: 'गोपनीयता नीति'
//             },
//       path: '/privacy-policy'
//     },
//     {
//       title: {
//                 en: 'Cookie Policy',
//                 hi: 'कुकी नीति'
//               },
//       path: '/cookie-policy'
//     },
//     {
//       title: {
//                 en: 'Terms of Use',
//                 hi: 'उपयोग की शर्तें'
//               },
//       path: '/terms-of-use'
//     }
//   ]
// };

export const links = {
  organization: [
    {
      title: {
        en: 'About',
        hi: 'आरटीएम लिंक',
      },
      path: '/about-us',
    },
    {
      title: {
        en: 'Careers',
        hi: 'आरटीएम लिंक',
      },
      path: '/about/careers',
    },
  ],
  resources: [
    {
      title: {
        en: 'RTM Link',
        hi: 'आरटीएम लिंक',
      },
      path: '/rtm-link',
    },
    {
      title: {
        en: 'Annual Reports',
        hi: 'वार्षिक रिपोर्ट',
      },
      path: '/annual-reports',
    },
    {
      title: {
        en: 'Events',
        hi: 'इवेंट्स',
      },
      path: '/events',
    },
    {
      title: {
        en: 'Photo Gallery',
        hi: 'फोटो गैलरी',
      },
      path: '/photo-gallery',
    },
    {
      title: {
        en: 'Tenders',
        hi: 'टेंडर',
      },
      path: '/tenders',
    },
    {
      title: {
        en: 'Notices',
        hi: 'सूचनाएँ',
      },
      path: '/notices',
    },
    {
      title: {
        en: 'RTI Section',
        hi: 'आरटीआई अनुभाग',
      },
      path: '/rti-section',
    },
  ],
  opportunities: [
    {
      title: {
        en: 'Vacancies',
        hi: 'रिक्तियाँ',
      },
      path: '/vacancies',
    },
    {
      title: {
        en: 'Recruitment Results',
        hi: 'भर्ती परिणाम',
      },
      path: '/recruitment-results',
    },
    {
      title: {
        en: 'Call For Proposals',
        hi: 'प्रस्ताव के लिए कॉल',
      },
      path: '/call-for-proposals',
    },
  ],
  portalsAndForms: [
    {
      title: {
        en: 'Download Forms',
        hi: 'फॉर्म डाउनलोड करें',
      },
      path: '/download-forms',
    },
    {
      title: {
        en: 'MIHIR Portal',
        hi: 'MIHIR पोर्टल',
      },
      path: '/mihir-portal',
    },
    {
      title: {
        en: 'NCMRWF Library Portal',
        hi: 'NCMRWF पुस्तकालय पोर्टल',
      },
      path: '/ncmrwf-library-portal',
    },
    {
      title: {
        en: 'Rajbhasha Portal',
        hi: 'राजभाषा पोर्टल',
      },
      path: '/rajbhasha-portal',
    },
  ],
  womenAndCitizenSupport: [
    {
      title: {
        en: 'ICC For Women',
        hi: 'महिलाओं के लिए आईसीसी',
      },
      path: '/icc-for-women',
    },
    {
      title: {
        en: 'Citizen Charter',
        hi: 'नागरिक चार्टर',
      },
      path: '/citizen-charter',
    },
    {
      title: {
        en: 'Grievance Cell',
        hi: 'शिकायत सेल',
      },
      path: '/grievance-cell',
    },
  ],
  communication: [
    {
      title: {
        en: 'Newsletter',
        hi: 'न्यूज़लेटर',
      },
      path: '/newsletter',
    },
    {
      title: {
        en: 'Useful External Info',
        hi: 'उपयोगी बाहरी जानकारी',
      },
      path: '/useful-external-info',
    },
    {
      title: {
        en: 'Disclaimer',
        hi: 'अस्वीकृति',
      },
      path: '/disclaimer',
    },
    {
      title: {
        en: 'Web Administrator',
        hi: 'वेब व्यवस्थापक',
      },
      path: '/web-administrator',
    },
    {
      title: {
        en: 'Contact Us',
        hi: 'संपर्क करें',
      },
      path: '/contact-us',
    },
  ],
  additionalLinks: [
    {
      title: {
        en: 'Privacy Policy',
        hi: 'गोपनीयता नीति',
      },
      path: '/privacy-policy',
    },
    {
      title: {
        en: 'Cookie Policy',
        hi: 'कुकी नीति',
      },
      path: '/cookie-policy',
    },
    {
      title: {
        en: 'Terms of Use',
        hi: 'उपयोग की शर्तें',
      },
      path: '/terms-of-use',
    },
  ],
};
